export default [
  {
    path: "/lalu-lintas-ternak/",
    component: () =>
      import("@/pages/lalu-lintas-ternak/lalu-lintas-ternak-list.vue"),
    meta: { title: "Daftar Lalu Lintas Ternak" },
  },
  {
    path: "/lalu-lintas-ternak/create",
    component: () =>
      import("@/pages/lalu-lintas-ternak/lalu-lintas-ternak-form.vue"),
    meta: { title: "Tambah Lalu Lintas Ternak" },
  },
  {
    path: "/lalu-lintas-ternak/detail/:id",
    component: () =>
      import("@/pages/lalu-lintas-ternak/lalu-lintas-ternak-detail.vue"),
    meta: { title: "Detail Lalu Lintas Ternak" },
  },
  {
    path: "/lalu-lintas-ternak/update/:id",
    component: () =>
      import("@/pages/lalu-lintas-ternak/lalu-lintas-ternak-update.vue"),
    meta: { title: "Edit Lalu Lintas Ternak" },
  },
  {
    path: "/lalu-lintas-ternak/import",
    component: () =>
      import("@/pages/lalu-lintas-ternak/lalu-lintas-ternak-import.vue"),
    meta: { title: "Import Lalu Lintas Ternak" },
  },
];
